// extracted by mini-css-extract-plugin
var _1 = "PostVerifiedBar-module__actions--BUAdp";
var _2 = "PostVerifiedBar-module__animatedBackground--RNI5Y";
var _3 = "PostVerifiedBar-module__previousHeader--ODjAP";
var _4 = "PostVerifiedBar-module__verificationEntries--BS0da";
var _5 = "PostVerifiedBar-module__verifierContainer--XPcnW";
var _6 = "PostVerifiedBar-module__verifierInfo--Vb8Bw";
var _7 = "PostVerifiedBar-module__verifierName--sy0Gq";
export { _1 as "actions", _2 as "animatedBackground", _3 as "previousHeader", _4 as "verificationEntries", _5 as "verifierContainer", _6 as "verifierInfo", _7 as "verifierName" }
